<template>
  <div class="gift">
    <div class="center wrapW">
      <div class="center_zi">
        <div class="name">想您所想，予您所需</div>
        <div class="Yname">PPT ONE CLICK GENERATION</div>
        <div class="describe">选品方案PPT一键生成，职场小白秒变采购高手！ ！</div>
        <img src="~@/assets/img/gift.png">
        <ul>
          <li class="iconfont">活动流程：选品</li>
          <li class="iconfont">加入方案</li>
          <li class="iconfont">导出方案</li>
          <li class="iconfont">审批采购</li>
        </ul>
      </div>
      <img src="~@/assets/img/gift2.png">
    </div>
  </div>
</template>

<script>
export default {
  name: 'scene',
  data () {
    return {
    }
  }
}
</script>
<style lang="stylus" scoped>
.gift
  margin-top 1.2rem
  text-align center
  background #F4F5F7
  padding .7rem 0 .55rem 0
  .center
    display flex
    align-items center
    justify-content space-between
    img
      margin-right .84rem
    .center_zi
      text-align left
      .name
        font-size .24rem
        color var(--hei)
        font-weight bold
        line-height .24rem
      .Yname
        margin-top .16rem
        font-size .20rem
        color #D22016
        font-weight bold
      .describe
        font-size .18rem
        margin-top .3rem
        color #666666
      img
        width .58rem
        margin-top .32rem
      ul
        display flex
        flex-flow row wrap
        margin-top .26rem
        li
          color #666666
          font-size .18rem
          position relative
          line-height 18px
          padding-right .49rem
        li::before
          content '\e631'
          font-size size
          border-radius 50%
          position absolute
          font-size 18px
          right .16rem
          top 0px
        li:last-child::before
          opacity 0
</style>



// WEBPACK FOOTER //
// src/pages/index/components/giftO.vue